<template>
  <PaperContainer class="container">
    <div class="all">
      <!-- 第一部分 -->
      <div class="part_one">
        <div class="pic">
          <a href="https://www.12371.cn/special/20jsizqh/" target="_blank" rel="noopener noreferrer"><img
              src="../assets/image/首页学习贯彻党的四中全会精神.png" alt="" srcset="" /></a>
          <img src="../assets/image/title.png" alt="" srcset="" />
        </div>
        <!-- 轮播图、通知公告、工作动态 -->
        <div class="show">
          <!-- swiper轮播图组件 -->
          <div class="swiper-column">
            <Swiper :is-choose-type="1" :list="swiperlist" @swiper="(swiper) => swiperInstance.value = swiper" />
          </div>
          <!-- 通知公告 -->
          <div class="notice">
            <el-menu :default-active="queryParams.type" class="el-menu-demo" mode="horizontal">
              <el-menu-item :index="'1'" @mouseenter="handleSelect('1')">通知公告</el-menu-item>
              <el-menu-item :index="'2'" @mouseenter="handleSelect('2')">工作动态</el-menu-item>
              <div class="more" @click="getMore(queryParams.type)">
                <p>More</p>
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </el-menu>

            <Transition name="fade" mode="out-in">
              <NoticeList :key="queryParams.type" :dataList="noticelist" />
            </Transition>
          </div>
        </div>
        <!-- 下方两个公告栏 -->
        <div class="gonggao-container">
          <div class="gonggao-item dangjian">
            <el-menu>
              <el-menu-item>党建动态</el-menu-item>
              <div class="more" @click="handleGonggaoClick('dangjian')">
                <p>More</p>
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </el-menu>
            <div class="gonggao-content">
              <div class="meeting-list">
                <div class="meeting-item" v-for="(item, index) in displayedDangjian" :key="index">
                  <a :href="item.url" target="_blank" class="meeting-name">
                    {{ item.name }}
                  </a>
                  <div class="meeting-time">{{ item.time }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="gonggao-item weisheng">
            <el-menu>
              <el-menu-item>卫生强基</el-menu-item>
              <div class="more" @click="handleGonggaoClick('weisheng')">
                <p>More</p>
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </el-menu>
            <div class="gonggao-content">
              <div class="empty-placeholder" v-if="!weishengList.length">
                <el-icon>
                  <FirstAidKit />
                </el-icon>
                <p>暂无卫生强基文章</p>
              </div>
              <ul v-else>
                <li v-for="(item, index) in weishengList" :key="index">
                  <a :href="item.link" target="_blank" rel="noopener noreferrer">
                    {{ item.title }}
                  </a>
                  <span>{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 第三排公告栏 -->
        <div class="gonggao-container">
          <div class="gonggao-item fenhui">
            <el-menu>
              <el-menu-item>分支机构活动</el-menu-item>
              <div class="more" @click="handleGonggaoClick('fenhui')">
                <p>More</p>
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </el-menu>
            <div class="gonggao-content">
              <div class="meeting-header">
                <div class="header-item">会议名称</div>
                <div class="header-item">会议地址</div>
                <div class="header-item">会议时间</div>
              </div>
              <!-- <div class="meeting-list">
                <div class="meeting-item" v-for="(item, index) in displayedMeetings" :key="index">
                  <a :href="item.url" target="_blank" class="meeting-name">
                    {{ item.name }}
                  </a>
                  <div class="meeting-address">{{ item.address }}</div>
                  <div class="meeting-time">{{ item.time }}</div>
                </div>
              </div> -->
              <div class="empty-placeholder" v-if="!huiyiList.length">
                <el-icon>
                  <Calendar />
                </el-icon>
                <p>暂无会议信息</p>
              </div>
              <div v-else class="meeting-list">
                <div class="meeting-item" v-for="(item, index) in huiyiList" :key="index">
                  <a :href="item.url" target="_blank" class="meeting-name">
                    {{ item.name }}
                  </a>
                  <div class="meeting-address">{{ item.address }}</div>
                  <div class="meeting-time">{{ item.time }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="gonggao-item weisheng">
            <el-menu class="custom-menu">
              <el-menu-item>生活方式医学与慢病管理大讲堂</el-menu-item>
              <div class="more" @click="handleGonggaoClick('dajiangtang')">
                <span>More</span>
                <el-icon>
                  <ArrowRightBold />
                </el-icon>
              </div>
            </el-menu>
            <div class="gonggao-content">
              <div class="empty-placeholder" v-if="!dajiangtangList.length">
                <el-icon>
                  <FirstAidKit />
                </el-icon>
                <p>暂无生活方式医学与慢病管理大讲堂内容 </p>
              </div>
              <ul v-else>
                <li v-for="(item, index) in dajiangtangList" :key="index">
                  <a :href="item.link" target="_blank" rel="noopener noreferrer">
                    {{ item.title }}
                  </a>
                  <span>{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 功能模块 -->
      <div class="part_two">
        <BoxChange />
      </div>

      <!-- 第三部分 友情链接 -->
      <div class="part_three">
        <div class="title">
          <div class="line"></div>
          <div class="title-item">
            <h2>友情链接</h2>
            <p>ZHENG WU GONG KAI</p>
          </div>
          <div class="line"></div>
        </div>
        <div class="images">
          <Swiper :is-choose-type="2" />
        </div>
      </div>
    </div>
  </PaperContainer>
</template>

<script lang="ts" setup>
import PaperContainer from '../components/paperContainer.vue';
import Swiper from '@/components/swiper.vue';
import NoticeList from '@/components/noticelist.vue';
import BoxChange from '@/components/boxChange/boxBottom.vue';
import { useRouter } from 'vue-router';
import { computed, ref, onMounted } from 'vue';
import { getNow, now } from '@/utils/getTime';
import { getSwiperList, getNoticeList, getNoticeSearch } from '@/api/index';
import emitter from '@/plugins/emitter';
import { getLatestMeetings } from '@/data/huiyi';
import { dangjian } from '@/data/dangjian';
import { getLatestJicengxunjiangArticles } from '@/data/weisheng';
import { getLatestDajiangtangArticles } from '@/data/dajiangtang';
// const swiperInstance = ref<any>(null);
const router = useRouter()
// 通知公告、工作动态
const queryParams = ref({
  pageNum: 1,
  pageSize: 8,
  // searchVal: "",
  type: "1",
  category: "",
})
// 轮播数据
const swiperlist = ref([]);
// 数据列表
const noticelist = ref([]);
// 科普园地数据
const kepuList = ref([]);
// 卫生强基数据
const weishengList = ref(getLatestJicengxunjiangArticles());
// 大讲堂数据 - 独立的数据源
const dajiangtangList = ref(getLatestDajiangtangArticles());
const huiyiList = ref(getLatestMeetings());
// 轮播数据获取 第一版
// const getLunboList = async () => {
//   const res = await getSwiperList() as any;
//   swiperlist.value = res;
// }
// 轮播数据获取 第二版
// const getLunboList = async () => {
//   try {
//     const res = await getSwiperList() as any;
//     // 确保数据格式正确，包含id, img, title等必要字段
//     swiperlist.value = res.map(item => ({
//       id: item.newsId, // 使用newsId作为文章ID
//       img: item.fileUrl, // 图片URL
//       title: item.fileName // 可以使用文件名作为标题，或从关联的文章获取标题
//     }));
//   } catch (error) {
//     console.error('获取轮播图数据失败:', error);
//     swiperlist.value = []; // 失败时设置为空数组
//   }
// }
// 修正后的数据映射
const getLunboList = async () => {
  try {
    const res = await getSwiperList() as any;
    // 确保映射正确的字段名
    swiperlist.value = res.map(item => ({
      id: item.id || item.articleId, // 兼容不同字段名
      img: item.img || item.coverImage || item.fileUrl, // 兼容不同字段名
      title: item.title || item.articleTitle || item.fileName // 兼容不同字段名
    }));
    console.log('轮播图数据:', swiperlist.value); // 添加日志以便调试
  } catch (error) {
    console.error('获取轮播图数据失败:', error);
    swiperlist.value = [];
  }
}

// 处理卫生强基More点击
const handleWeishengMore = () => {
  router.push('/weisheng');
}

// 处理大讲堂More点击
const handleDajiangtangMore = () => {
  // 这里可以跳转到专门的大讲堂页面，或者保持当前页面
  // router.push('/dajiangtang');
  console.log('跳转到生活方式医学与慢病管理大讲堂页面');
}

//分会
const handleFenhuiMore = () => {
  router.push('/huiyi'); // 跳转到会议页面
}


// 动态公告菜单切换
const handleSelect = async (index: any) => {
  queryParams.value.type = index;
  sessionStorage.setItem('numberIdx', `1-${index}`);
  const { list } = await getNoticeList(queryParams.value) as any;
  noticelist.value = list;
}


// 更多
const getMore = (index: any) => {
  sessionStorage.setItem('changeTitle', '学会通知公告');
  emitter.emit('change-title', '学会通知公告');
  router.push({
    path: index == 1 ? '/learnNotice' : '/learnwork',
  })
}

// 处理公告栏点击
const handleGonggaoClick = (type: string) => {
  if (type === 'weisheng') {
    handleWeishengMore();
  } else if (type === 'dangjian') {
    router.push('/dangjian');
  } else if (type === 'kepu') {
    router.push('/kepu');
  } else if (type === 'dajiangtang') {
    router.push('/jiangtang');
  }else if (type === 'fenhui') {
    handleFenhuiMore(); // 添加分支机构活动处理
  }
}

onMounted(async () => {
  getNow();
  // 轮播数据
  getLunboList();
  // 通知公告
  handleSelect(queryParams.value.type);
  // 这里可以添加获取科普园地和卫生强基数据的逻辑
  // getKepuList();
  // getWeishengList();
})


// const displayedMeetings = computed(() => {
//   return [...meetings]
//     .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
//     .slice(0, 5)
//     .reverse(); // 反转数组
// });
const displayedDangjian = computed(() => {
  return [...dangjian]
    .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
    .slice(-5)
    .reverse(); // 反转数组
});

</script>

<style lang="scss">
@import '../style/home.scss';

/* 内容切换时淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>